import { render, staticRenderFns } from "./ApplicantInfoBlock.vue?vue&type=template&id=50b81d87&scoped=true"
import script from "./ApplicantInfoBlock.vue?vue&type=script&lang=js"
export * from "./ApplicantInfoBlock.vue?vue&type=script&lang=js"
import style0 from "./ApplicantInfoBlock.vue?vue&type=style&index=0&id=50b81d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b81d87",
  null
  
)

export default component.exports